import { authGet } from "@api";
import { AUTH_URL } from "@constants";
import { GetSsoTokenEmailResponse } from "@types";

export const getSsoTokenEmail = (
  token: string
): Promise<GetSsoTokenEmailResponse> => {
  const url = `${AUTH_URL}/sso/sso-token-domains?t=${token}`;
  return authGet<GetSsoTokenEmailResponse>(url);
};
